const SearchQueryKey = {
  RECENT_SEARCH_KEY: 'RECENT_SEARCH_KEY',
  RECOMMEND_SEARCH: 'RECOMMEND_SEARCH',
  SEARCH: 'SEARCH',
  SEARCH_RESULT: 'SEARCH_RESULT',
};

export default SearchQueryKey;
